import { cx } from '@vizit/theme';
import { Heading, type HeadingProps, HeadingVariant } from '../heading';

function DialogTitle(props: HeadingProps) {
  const { className, ...other } = props;

  return <Heading variant={HeadingVariant.H6} className={cx('font-semibold', className)} slot="title" {...other} />;
}

export { DialogTitle };
